import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/react";

var container = function container(theme) {
  return {
    border: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    marginBottom: '1.5em'
  };
};

var totalRow = function totalRow(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.2em 2em',
    backgroundColor: theme.gray50,
    borderBottom: "1px solid ".concat(theme.gray100),
    '& .total-label': {
      fontSize: '1.4rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    },
    '& .total-value': {
      fontSize: '1.8rem',
      fontWeight: 700,
      color: theme.primary
    }
  };
};

var grid = function grid(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    '& > div:nth-of-type(odd)': {
      borderRight: "1px solid ".concat(theme.gray100)
    },
    '@media (max-width: 700px)': {
      gridTemplateColumns: '1fr',
      '& > div:nth-of-type(odd)': {
        borderRight: 'none'
      },
      '& > div': {
        borderBottom: "1px solid ".concat(theme.gray100)
      },
      '& > div:last-of-type': {
        borderBottom: 'none'
      }
    }
  };
};

var section = {
  padding: '1.4em 2em'
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    marginBottom: '1em',
    '& i': {
      fontSize: '1.5rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray400,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var row = function row(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5em 0',
    '& .label': {
      fontSize: '1.3rem',
      color: theme.gray400
    },
    '& .value': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};

var fmt = function fmt(val, cur) {
  return "".concat(val !== null && val !== void 0 ? val : '--', " ").concat(cur);
};

var PastPrincipalValuesList = function PastPrincipalValuesList(_ref) {
  var data = _ref.data,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '' : _ref$currency;
  return ___EmotionJSX("div", {
    css: container
  }, ___EmotionJSX("div", {
    css: totalRow
  }, ___EmotionJSX("span", {
    className: "total-label"
  }, "\u041E\u0431\u0449\u0430 \u043C\u0438\u043D\u0430\u043B\u0430 \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("span", {
    className: "total-value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_principal, currency))), ___EmotionJSX("div", {
    css: grid
  }, ___EmotionJSX("div", {
    css: section
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-history"
  }), ___EmotionJSX("span", null, "\u041C\u0435\u0441\u0435\u0446\u0438 1 \u2013 5")), [1, 2, 3, 4, 5].map(function (m) {
    var _data$months;

    return ___EmotionJSX("div", {
      css: row,
      key: m
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u041C\u0435\u0441\u0435\u0446 -", m), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : (_data$months = data.months) === null || _data$months === void 0 ? void 0 : _data$months["month-".concat(m)], currency)));
  })), ___EmotionJSX("div", {
    css: section
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-history"
  }), ___EmotionJSX("span", null, "\u041C\u0435\u0441\u0435\u0446\u0438 6 \u2013 10")), [6, 7, 8, 9, 10].map(function (m) {
    var _data$months2;

    return ___EmotionJSX("div", {
      css: row,
      key: m
    }, ___EmotionJSX("span", {
      className: "label"
    }, "\u041C\u0435\u0441\u0435\u0446 -", m), ___EmotionJSX("span", {
      className: "value"
    }, fmt(data === null || data === void 0 ? void 0 : (_data$months2 = data.months) === null || _data$months2 === void 0 ? void 0 : _data$months2["month-".concat(m)], currency)));
  }))));
};

PastPrincipalValuesList.propTypes = {
  data: PropTypes.object,
  currency: PropTypes.string
};
export default PastPrincipalValuesList;